import { Inbound } from '@/models/Inbound';
import { getField, updateField } from 'vuex-map-fields';
import { httpError } from '@/models/httpError';
import { HTTP } from '@/http-common';
import { StateBased } from '../../../models/StateBased';

const state = {
  rows: [],
  message: new httpError(),
  states: [],
};

//getters

const getters = {
  getField,
};

//Mutations
const mutations = {
  setInbound(state, inbounds) {
    state.rows = inbounds;
  },

  setStates(state, states) {
    state.states = states;
  },
  addRow(state) {
    if (state.rows.length > 0) {
      state.rows.push(new Inbound({ stateBased: [] }));
    } else {
      state.rows = [new Inbound({ stateBased: [] })];
    }
  },
  deleteRow(state) {
    state.rows.pop();
  },
  setProgress(state, message) {
    state.message = message;
  },
  removeRow(state, index) {
    state.rows.splice(index, 1);
  },
  addStateBased(state, stateBased) {
    stateBased.routes.forEach((element) => {
      state.rows[stateBased.index].stateBased.push(element);
    });
  },
  removeStateBased(state, index) {
    state.rows[index].stateBased.length = 0;
    state.rows[index].stateBased = [];
  },
  updateStateBased(state, serviceNumbers) {
    state.stateBased.array
      .filter((e) => e.serviceNumber == serviceNumbers.oldNUmber)
      .forEach((element) => {
        element.serviceNumber = serviceNumbers.newNumber;
      });
  },
  updateField,
};

//ACTIONS
const actions = {
  reset({ commit }) {
    commit('setInbound', [new Inbound()]);
    commit('setStates', [
      'QLD',
      'NSW',
      'ACT',
      'VIC',
      'SA',
      'TAS',
      'NT',
      'WA',
      'Mobiles',
    ]);
  },
  deleteRouting({ commit }, index) {
    return new Promise((resolve) => {
      commit('removeStateBased', index);
      resolve(true);
    });
  },
  updateStateBased({ commit }, serviceNumbers) {
    commit('updateStateBased', serviceNumbers);
  },
  changeRouting({ commit, state }, index) {
    commit('addStateBased', {
      index: index,
      routes: state.states.map(
        (x) =>
          new StateBased({
            state: x,
            answeringPoint: null,
            inboundID: 0,
          })
      ),
    });
  },
  async getInbound({ commit, dispatch, rootState }) {
    try {
      var order = await HTTP.get(
        'order/GetInbound/' + rootState.orders.rows[0].orderID
      );
      if (order.data == null || order.data.length == 0) {
        order.data = [new Inbound({ orderType: 'new' })];
      }
      commit('setInbound', order.data);
      dispatch(
        'setMessage',
        new httpError({ message: 'Retreived OK', httpStatus: 200 })
      );
      return Promise.resolve(order.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({
          message: 'Error getting order:' + err,
          httpStatus: 500,
        })
      );
      return Promise.reject(err);
    }
  },
  async saveInbound({ commit, dispatch, rootState, state }, row) {
    try {
      var order = await HTTP.post(
        'order/AddInbound/' + rootState.orders.rows[0].orderID,
        typeof row !== 'undefined' ? [row] : state.rows
      );
      commit('setInbound', order.data);
      dispatch(
        'setMessage',
        new httpError({ message: 'saved OK', httpStatus: 200 })
      );
      return Promise.resolve(order.data);
    } catch (err) {
      dispatch(
        'setMessage',
        new httpError({ message: 'unable to save:' + err, httpStatus: 500 })
      );
      return Promise.reject(err);
    }
  },
  async removeRows({ state, commit, rootState }, newVal) {
    var oldVal = 0 || state.rows.length;
    var rows = [];
    for (var i = oldVal; i > newVal; i--) {
      if (state.rows[i - 1].inboundID > 0) {
        rows.push(state.rows[i - 1].inboundID);
      }
      commit('deleteRow');
    }
    if (rows.length > 0) {
      try {
        var mobiles = await HTTP.delete(
          'order/DeleteInbound/' + rootState.orders.rows[0].orderID,
          { data: rows }
        );
        return Promise.resolve(mobiles);
      } catch (e) {
        return Promise.reject(e);
      }
    }
    return Promise.resolve();
  },
  deleteRow({ state, rootState, commit, dispatch }, index) {
    return new Promise((resolve, reject) => {
      HTTP.delete('order/DeleteInbound/' + rootState.orders.rows[0].orderID, {
        data: [state.rows[index].inboundID],
      })
        .then(() => {
          commit('deleteRow', index);
          resolve();
        })
        .catch((err) => {
          dispatch(
            'setMessage',
            new httpError({
              message: 'unable to save:' + err.message,
              httpStatus: 500,
            })
          );
          reject(err.message);
        });
    });
  },
  setMessage({ commit }, message) {
    commit('setProgress', message);
    if (message.httpStatus !== 500)
      setTimeout(() => {
        commit('setProgress', new httpError());
      }, 2000);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
